import styled from 'styled-components'

// Components
import Button from 'components/Button'

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-size: ${({ theme }) => theme.fontSizes.large};
  margin: 32px 0 8px 0;
`

export const Description = styled.p`
  margin-bottom: 16px;
`

export const RecoveryCodes = styled.ul`
  text-align: center;
  margin: 0 0 24px 0;
  padding: 24px;
  border: 1px dashed ${({ theme }) => theme.colors.border[1]};
  border-radius: ${({ theme }) => theme.radii.xlarge};
  background-color: ${({ theme }) => theme.colors.background.secondary[2]};
  list-style: none;
  columns: 2;
`

export const RecoveryCode = styled.li`
  display: block;
  font-family: ${({ theme }) => theme.fonts.monospace};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-size: ${({ theme }) => theme.fontSizes.body};

  :not(:last-child, :nth-child(5)) {
    padding-bottom: 24px;
  }
`

export const Buttons = styled.div`
  display: flex;
  margin-bottom: 16px;
`

export const StyledButton = styled(Button)`
  flex: 1;
`

export const FormWrapper = styled.div`
  margin-bottom: 32px;
`
